import { ThemeProvider } from '@emotion/react';
import { ThemeProvider as ThemeProviderOld } from 'emotion-theming';
import { merge } from 'lodash';
import React from 'react';
import global from "./styles/global";
import defaultTheme from "./styles/theme";
import { Global } from "./utils";
import ToastProvider from './ToastProvider';
var UIProvider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? {} : _b;
    var mergedTheme = merge(defaultTheme, theme);
    return (React.createElement(ThemeProvider, { theme: mergedTheme },
        React.createElement(ThemeProviderOld, { theme: mergedTheme },
            React.createElement(ToastProvider, null,
                React.createElement(Global, { styles: global(mergedTheme) }),
                children))));
};
export default UIProvider;
//# sourceMappingURL=UIProvider.js.map